<template>
    <b-card no-body>
        <h3 slot="header" class="my-1 d-flex justify-content-between align-items-center">
            <span class="text-primary">{{$t(cardData.i18nName)}}</span>
        </h3>
        <div id="itemsResultTable" class="content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <!--          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionFilter">-->
                    <div class="card-body">
                        <form>
                            <em-filter :entity="modelName" ref="emListFilter"
                                       @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                        </form>
                    </div>
                    <!--          </div>-->
                </div>
            </div>
            <div id="emMenuResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :title="cardData.i18nName"
                                      ref="emTable" is-edit-card import-enabled
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"></em-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </b-card>
</template>

<script>
    import emCommonListMixin from "@/mixin/em/common/list";
    export default {
        name: "EmCardEdit",
        mixins: [emCommonListMixin],
        computed:{
            modelName(){
                return this.cardData.entityName
            },
          $_emCommonListMixin_needToRefresh: {
            get() {
              return this.$store.state[this.modelName] !== undefined && this.$store.state[this.modelName].needToRefresh;
            },
            set(value) {
              this.$store.commit(`${this.modelName}/setNeedToRefresh`, value)
            }
          }
        },
        props: {
            cardData: {
                type: Object,
                required: true
            }
        },
      watch: {
        $_emCommonListMixin_needToRefresh(newValue, oldValue) {
          newValue && this.$refs["emListFilter"] && this.$refs["emListFilter"].doQuery()
        }
      },
      mounted() {
        // this.$store.dispatch("emBase/emBaseQueryByFilter", {entity: this.modelName})
        this.$_emCommonListMixin_needToRefresh && this.$refs["emListFilter"] && this.$refs["emListFilter"].doQuery()
      }
    };
</script>

